import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import {
  slots,
  zoneCoils,
  zoneDies,
  zoneSingulars,
  getCoilStock,
  debuggerLiftPosition,
  debuggerDepositPosition,
  timeSubscription,
  liftws,
  depositws,
  getCoilStockByDeposit,
  getCranes,
} from "src/app/models/graphQL/swhc/swhc.request";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class SwhcService {
  constructor(private _apollo: Apollo) {}

  slots() {
    return this._apollo
      .watchQuery<any>({
        query: slots,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.slots));
  }

  zoneCoils() {
    return this._apollo
      .watchQuery<any>({
        query: zoneCoils,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.zoneCoils));
  }

  zoneDies() {
    return this._apollo
      .watchQuery<any>({
        query: zoneDies,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.zoneDies));
  }

  zoneSingulars() {
    return this._apollo
      .watchQuery<any>({
        query: zoneSingulars,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.zoneSingulars));
  }

  getCoilStock() {
    return this._apollo
      .watchQuery<any>({
        query: getCoilStock,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.getMaterialStock));
  }

  debuggerLift(x: string, y: string, z: string) {
    return this._apollo.mutate<any>({
      mutation: debuggerLiftPosition,
      variables: {
        x: x,
        y: -z,
        z: y, //cambios de coordenadas para que coincidan con el sistema de coordenadas de la grua
        crane: "CRANE1",
      },
      fetchPolicy: "network-only",
    });
  }

  debuggerDeposit(x: string, y: string, z: string) {
    return this._apollo.mutate<any>({
      mutation: debuggerDepositPosition,
      fetchPolicy: "network-only",
      variables: {
        x: x,
        y: -z,
        z: y,
        crane: "CRANE1",
      },
    });
  }

  timeSubscription() {
    return this._apollo
      .subscribe<any>({
        query: timeSubscription,
        fetchPolicy: "network-only",
      })
      .pipe(map((response) => response.data));
  }

  liftws() {
    return this._apollo
      .subscribe<any>({
        query: liftws,
        fetchPolicy: "network-only",
      })
      .pipe(map((response) => response.data));
  }

  depositws() {
    return this._apollo
      .subscribe<any>({
        query: depositws,
        fetchPolicy: "network-only",
      })
      .pipe(map((response) => response.data));
  }

  getCoilStockByDeposit(uuid: string) {
    return this._apollo
      .watchQuery<any>({
        query: getCoilStockByDeposit,
        variables: {
          uuid: uuid,
        },
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(
        map((response) => response.data.getCoilStockByDeposit)
      );
  }

  getCranes() {
    return this._apollo
      .watchQuery<any>({
        query: getCranes,
        fetchPolicy: "network-only",
      })
      .valueChanges.pipe(map((response) => response.data.getCranes));
  }
}
